module.exports = "/assets/data/da6220d2ce691c7af32591cd9b637a7c-SE7.data.json";